export enum STATISTIC {
  GENERAL = 'general',
  CAMPAIGN = 'campaign',
  HIGHCHARTS_DEFAULT_HEIGHT = 400,
  HIGHCHARTS_DEFAULT_BAR_HEIGHT = 40,
  HIGHCHARTS_ADDITIONAL_SPACE = 80,
}
